import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const groups = [
  {
    title: 'Sustainability Mobility Characterization',
    images: [
      '/img/carrusel1/foto1.png',
      '/img/carrusel1/foto2.png',
      '/img/carrusel1/foto3.png',
    ],
  },
  {
    title: 'Tools to empower communities (Stakeholders maps)',
    images: [
      '/img/carrusel1/foto4.png',
      '/img/carrusel1/foto5.png',
      '/img/carrusel1/foto6.png',
      '/img/carrusel1/foto7.png',
    ],
  },
  {
    title: 'Fuzzy Cognitive Maps',
    images: [
      '/img/carrusel1/foto8.png',
      '/img/carrusel1/foto9.png',
    ],
  },
  {
    title: 'Multi-Objective Optimization Problems (MOP)',
    images: [
      '/img/carrusel1/foto10.png',
    ],
  },
];

// Arrays planos para el carrusel
const images = groups.flatMap(group => group.images);
const captions = groups.flatMap(group => Array(group.images.length).fill(group.title));

const Card = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const prevSlide = () => setCurrent(prev => (prev - 1 + images.length) % images.length);
  const nextSlide = () => setCurrent(prev => (prev + 1) % images.length);

  return (
    <Wrapper>
      <Slide>
        <Img
          src={images[current]}
          alt={`slide-${current}`}
          onError={e => { e.currentTarget.src = '/img/placeholder.png'; }}
        />
      </Slide>

      <NavButton left onClick={prevSlide}>‹</NavButton>
      <NavButton onClick={nextSlide}>›</NavButton>

      <Caption>{captions[current]}</Caption>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  height: 400px;
  margin: 0 auto;
  overflow: hidden;
  background: transparent;
`;

const Slide = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Img = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;


const NavButton = styled.button`
  position: absolute;
  top: 50%;
  ${props => props.left ? 'left: 1rem;' : 'right: 1rem;'}
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #00000;
  font-size: 8rem;
  padding: 0;
  line-height: 1;
  cursor: pointer;
  z-index: 10;
`;

const Caption = styled.div`
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  background: rgba(255,255,255,0.7);
  padding: 0.3rem 0;
`;

export default Card;
